import React, { Component } from 'react';
import Global from "../../customlib/Global";
import Api from "../../customlib/Api";
import axios from 'axios';
import { Box, Button, Chip, CircularProgress, Dialog, DialogContent, Divider, LinearProgress } from '@mui/material';
import checkInTimeMp3File from "../../sound/check_in_time.mp3";
import { AlarmOn, QrCode, Warning } from '@mui/icons-material';
import { FaBullseye } from 'react-icons/fa';

class WahaNotify extends Component {
    state = { 
        showDialogCheckpoint : false,
        notifyData: null,
        isLoadingQR: false,
        imageData: null,//{mimetype, data}
        showQR: false
    } 

    componentDidMount() {
        Global.getSocket().on("notifyWahaSessionNeedScanQR", data => {

            const wahaSession = Global.getSwitchAppProfile().session;

            let findNotif = data?.message.find(item => item.session === wahaSession);

            if(findNotif){
                this.setState({showDialogCheckpoint: true, notifyData: findNotif}, () => {
                    // this.getQRCode();
                });
            }

            console.log("LOG___notify_waha", data, findNotif, wahaSession);
        });
    }

    resetCheckpoint = () => {
        this.setState({isCheckpointMissed: false, checkpointData: null});
    }

    closeCheckpoint = () => {
        this.setState({showDialogCheckpoint: false});
    }

    getQRCode = () => {
        this.setState({isLoadingQR: true}, () => {

            let params = {
                appProfileId: Global.getSwitchAppProfile()._id
            };

            axios
            .post(Api.getWahaQRCode(), params, Api.getRequestHeader())
            .then((response) => {
                console.log("QRRESPONSE : ", response.data);
                let responseData = response.data;
                
                this.setState({imageData: responseData.data, isLoadingQR: false});
            })
            .catch((error) => {
                this.setState({isLoadingQR: false});
                console.error("There was an error!", error);
            });
        });
    }

    toggleShowQr = () => {
        this.setState({showQR: !this.state.showQR}, () => {
            if(this.state.showQR){
                this.getQRCode();
            }
        });
    }

    render() { 
        return (<>
        
            {
                this.state.showDialogCheckpoint && (
                    <Dialog open={this.state.showDialogCheckpoint} >
                        <DialogContent>
                            <Box>
                                <Box textAlign={"center"} fontWeight={"bold"}>
                                    <Warning sx={{width: "70px", height: "70px"}} color='error' />
                                </Box>
                                <Box marginTop={"10px"} textAlign={"center"} fontWeight={"bold"}>
                                    {this.state.notifyData?.appLabel} belum bisa digunakan
                                </Box>
                                <Box marginTop={"10px"} fontWeight="bold" fontSize={"30px"} textAlign={"center"} sx={{color: "red"}}>
                                    {this.state.notifyData?.status}
                                </Box>
                                <Box textAlign={"center"}>
                                    <Chip label={`Session : ${this.state.notifyData?.session}`} color="warning" />
                                </Box>
                                <Divider color='error' sx={{mt: "10px", mb: "10px"}} />

                                {
                                    !this.state.showQR && (
                                        <Button onClick={this.toggleShowQr} variant='contained' color='success' fullWidth>Tampilkan QR <QrCode /></Button>
                                    )
                                }

                                {
                                    !this.state.isLoadingQR && this.state.imageData && this.state.showQR && (
                                        <Box textAlign={"center"}>
                                            <img
                                                src={`data:${this.state.imageData.mimetype};base64,${this.state.imageData.data}`}
                                                alt="Gambar dari Base64"
                                                className="rounded-xl shadow-lg max-w-xs"
                                            />
                                            <br />
                                            <Button variant='text' onClick={this.getQRCode} color='secondary'>Reload QR</Button>
                                        </Box>
                                    )
                                }

                                {
                                    this.state.isLoadingQR && this.state.showQR && (
                                        <Box textAlign={"center"}>
                                            <CircularProgress size={"25px"} />
                                            <Box></Box>
                                            Loading QR
                                        </Box>
                                    )
                                }
                                <Divider color='error' sx={{mt: "10px", mb: "10px"}} />
                                <Box textAlign={"center"} fontWeight={"bold"}>
                                    <Button onClick={() => {this.closeCheckpoint();}} fullWidth variant='contained' color='error'>Tutup</Button>
                                </Box>
                            </Box>
                        </DialogContent>
                    </Dialog>
                )
            }
        
        </>);
    }
}
 
export default WahaNotify;